<button
  class="file-label no-style-button"
  [class.show-controls-on-hover]="showControlsOnlyOnHover()"
  [class.disabled]="disabled()"
  (click)="onDownloadFile()"
>
  <div class="title">
    <div>
      <i class="icon ic-file-16"></i>
    </div>

    <div
      class="file-name"
      placement="top"
      container="body"
      tooltipClass="tooltip-info"
      [ngbTooltip]="fileName()"
    ><ng-content/>{{ fileName() }}</div>
  </div>

  <div class="controls d-flex hide-empty">
    @if (!hideDownloadBtn()) {
      <app-ag-action-icon-button
        iconClass="ic-download-16"
        [disabled]="disabled()"
        (action)="onDownloadFile(); $event.preventDefault(); $event.stopPropagation();"
      />
    }

    @if (!hideDeleteBtn()) {
      <app-ag-action-icon-button
        iconClass="ic-trash-16"
        [disabled]="disabled()"
        (action)="onDeleteFile(); $event.preventDefault(); $event.stopPropagation();"
      />
    }
  </div>
</button>
